export default {
  banner: {
    header: 'You have a great chance of getting a business loan*',
    disclaimer: '*This is not a pre-approved offer of credit. Chance of being approved is estimated and not guaranteed, using internal and external data, including your PayPal account history, "Great" means the estimated chance of approval is 70%+: Subject to credit approval.',
  },
};
